import React from "react";
import i18n from '../../../../utils/ChrI18n';
import ChrWordCloud from "../../../generic/Utils/ChrWordCloud";

const ResponsesWidget = ({headerText, totalResponsesCount, topWordsData, colorScale, wordCloudId}) => {
  return (
    <>
      <div className="font-14 font-600">{headerText}</div>
      <div className="font-12 text-muted">{i18n.t("widgets.in_a_word_responses.responses_count", {count: totalResponsesCount})}</div>
      <div className="d-flex justify-content-center align-items-center" style={{height: "225px"}}>
        <ChrWordCloud 
          words={topWordsData} 
          width={400} 
          height={150} 
          colorScale={colorScale}
          skipReRendersForSameWords={true}
          wordCloudId={wordCloudId}
        />
      </div>
    </>
  )
}

export default ResponsesWidget;